import { Dispatch, SetStateAction } from 'react';

import { BodySmall, Box, FileSelectorFileType, Modal, ModalFooter, ModalHeader } from '@parspec/pixel';

import FilesTabsWrapper from 'src/features/BOM/shared/uploadFileModal/FileTabs';
import { UploadedFilePath } from 'src/features/BOM/shared/types';
import { SUBMITTAL_PACKAGE_ALLOWED_FILE_TYPES } from 'src/features/BOM/ImportMoreProducts/shared/constants';
interface IFileType {
    file: FileSelectorFileType;
    s3_file_path?: string;
}
interface UploadFileModalProps {
    open: boolean;
    onCloseClick: () => void;
    onUpload?: (files: IFileType[]) => void;
    onConfirm?: any;
    fileRequiredError?: string
    setUploadedFile?: Dispatch<SetStateAction<IFileType[] | null>>;
    setUploadedFilePath?: Dispatch<SetStateAction<UploadedFilePath | null>>;
    isLoading?:boolean;
    setFileRequiredError:Dispatch<SetStateAction<string | undefined>>;
    onSelectionChanged?: (param: any) => void;
}

export const UploadFileModal = (props: UploadFileModalProps) => {
    const { open, onCloseClick, onUpload, onConfirm, fileRequiredError, setUploadedFile, setUploadedFilePath, isLoading ,setFileRequiredError ,onSelectionChanged} = props;
    const header = <ModalHeader title="Add Attachment" onClose={onCloseClick} />;
    const footer = (
        <ModalFooter
            onReject={()=>{
                setFileRequiredError('')
                setUploadedFilePath?.(null)
                onCloseClick()
            }}
            onAccept={() => { onConfirm() }}
            continueButtonLabel="Add"
            helperText={<BodySmall color="error">{fileRequiredError}</BodySmall>}
            isLoading={isLoading}
        />
    );

    return (
        <Modal header={header} footer={footer} open={open}>
            <form>
                <Box width="546px" position="relative" height={'100%'}>
                    <Box>
                        <FilesTabsWrapper
                            onUpload={onUpload}
                            setUploadedFile={setUploadedFile}
                            setUploadedFilePath={setUploadedFilePath}
                            acceptedFileTypes={SUBMITTAL_PACKAGE_ALLOWED_FILE_TYPES}
                            onSelectionChanged={onSelectionChanged}

                        />

                    </Box>
                </Box>
            </form>
        </Modal>
    );
};
